import { useCallback, useState } from "react";

import useDropdownRef from "@/util/use-dropdown-ref.mjs";

// TODO: pls remove this kode, wrapper of:
// - useDropdownRef
// - useDropdown (this)
// dont just write new fns from scratch
export default function useDropdown() {
  const [dropdown, setDropdown] = useState(false);

  const toggleDropdown = useCallback(() => {
    queueMicrotask(() => {
      setDropdown(!dropdown);
    });
  }, [dropdown]);

  const closeDropdown = useCallback(() => {
    setDropdown(false);
  }, []);

  const ref = useDropdownRef({
    onClickOutside: closeDropdown,
    onWindowResize: closeDropdown,
    onAssignNode: () => {},
  });

  return {
    dropdown,
    setDropdown,
    toggleDropdown,
    closeDropdown,
    ref,
  };
}
